import { TextField } from '@mui/material'
import prefStyles from '@/components/Settings/SettingsPreferenceSection.module.scss'

/**
 * @param {{
 *   'aria-label': string,
 *   value: string,
 *   onChange: (value: string) => void,
 *   placeholder?: string,
 * }} props
 */
export function PreferenceTextInput({ 'aria-label': ariaLabel, value, onChange, placeholder }) {
  return (
    <TextField
      size="small"
      variant="outlined"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      inputProps={{ 'aria-label': ariaLabel }}
      className={prefStyles.textField}
    />
  )
}
